<template>
  <div>
      <Header title="总体评价" type="0" :route="'/student/teachEvaluate_10407?queryData='+JSON.stringify(initParm)" ></Header>
      <div class="tittleDiv">
         <div class="list-head">
          <p>{{baseData.kcmc}}</p>
          <ul>
            <li>上课老师：{{baseData.teacherName}}</li>
            <li>完成状态：{{baseData.issave=='1'?'已评':'未评'}}</li>
          </ul>
         </div>
      </div>
      <div class="evaluate_content">
        <div>
             <div style="width: 100%;">
              <p>请选择下列指标</p>  
              <van-radio-group  v-model="radioName"  :disabled="baseData.issubmit=='1'?true:false"   class="w-d-radio-group">
                  <van-cell-group >
                    <van-cell v-for="(item, index) in zbList" :key="index" :title="item.mc" clickable  @click="radioClick(index,item.pj15id)">
                      <template #right-icon>
                        <van-radio :name="index" >
                          <template #icon="props">
                            <img class="img-icon" :src="props.checked? activeIcon : inactiveIcon" />
                          </template>
                        </van-radio>
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
             </div>
             
        </div>
        </div>

        <div class="grey-contain_div" ></div>
      <div class="history-btn" v-if="baseData.issubmit!='1'">
        <button @click="submintPjData('1')">提交</button>
      </div>
  </div>
</template>

<script>
  import {Api} from '../../../utils/axios'
  const icon1 = require('@/assets/images/assessment/check-white.svg')
  const icon2 = require('@/assets/images/assessment/checked.svg')
  export default {
    data(){
      return{
        mb1:'0',
        radio:'1',
        inactiveIcon: icon1,
        activeIcon: icon2,
        evaluateList:[],
        warning:'',
        baseData:[],
        evaText:'',
        zbList:[],
        zbIndexList:[],
        radioName:'',
        zbid:'',
        initParm:[]
      }
    },
    methods:{
      async submintPjData(submittype){
        if(this.zbid==''){
           this.$toast("请选择一个指标评价！");
            return;
        }
        const params = {
          pj09id:this.baseData.pj09id,
          radioName:this.zbid,
          pj01id: this.baseData.pj01id,
          batchId: this.baseData.batchId,
          pj05id: this.baseData.pj05id,
          pj02id: this.baseData.pj02id,
          pj0502id:this.baseData.batchId
        };
        const res = await Api.submitEvaluateZtpj(params);
        if(res.code=='1'){
          this.$toast("提交成功！");
          
          let params = {
          pj01id: this.baseData.pj01id,
          batchId: this.baseData.batchId,
          pj05id: this.baseData.pj05id,
          pj02id: this.baseData.pj02id,
          pj0502id:this.baseData.batchId,
          jg0101id:this.baseData.jg0101id
        }
        console.log("AAA",params)
          setTimeout(() => {
          this.$router.push({
             path:'/student/teachEvaluate_10407',
             query:params
            });
            }, 1500);
            }
      },
      radioClick(index,pj15id){
        if(this.baseData.issubmit=='1'){
          return;
        }
        this.radioName = index;
        this.zbid = pj15id;
      }
    },
    created(){
      this.$store.state.evaOptCheck = [];
      this.baseData = JSON.parse(this.$route.query.dataObj);
      this.zbList = this.baseData.zbList
      this.baseData.issubmit='0'
      this.initParm.pj01id = this.baseData.pj01id,
        this.initParm.batchId=this.baseData.batchId,
        this.initParm.pj05id= this.baseData.pj05id,
        this.initParm.pj02id=this.baseData.pj02id,
        this.initParm.pj0502id=this.baseData.batchId,
        this.initParm.lx=1;
    },
  }
</script>

<style lang="less" scoped>
.tittleDiv{
  position: fixed;
  top: 50px;
  padding: 2% 5% 2%;
	background-color: #ffffff;
	height: 90px;
  width: 90%;
  z-index: 99999;
	.list-head {
	  height: 100%;
	  background-image: url("../../../../static/image/head.png");
	  background-size: 100% 100%;
	  background-repeat: no-repeat;
	  display: flex;
	  padding: 3% 5%;
	  box-sizing: border-box;
	  position: relative;
	  flex-direction: column;
    p {
		height: 22px;
		font-family: PingFangSC-Medium;
		font-size: 18px;
		color: #fff;
		letter-spacing: 0;
		line-height: 22px;
		font-weight: 500;
		margin-bottom: 2%;
    text-overflow: ellipsis;
    overflow: hidden;
	  }
    ul li {
		  height: auto;
		  font-family: PingFangSC-Regular;
		  font-size: 14px;
		  color: #fff;
		  letter-spacing: 0;
		  margin-bottom: 1%;
		  opacity: 0.8;
		}
  }
}
.grey-contain{display: flex;align-items: center;}
.grey-contain h4{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 22px;}
  .grey-contain button{background-color: @attendance-background-color-1;border-radius: 3px;color: @attendance-color-3;height: 45px;width: 70px;}
  .grey-contain .contain-txt1{line-height: 17px;}
  .grey-contain  p{margin-bottom: 2px;}
  .delay-btn{position: absolute;bottom: 20px;width: 100%;text-align: center;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 90%;border-radius: 3px;}
  .history{border-radius: 3px;background-color: @attendance-background-color-13;color: @attendance-color-3;height: 45px;width: 70px;display: flex;flex-direction: column;align-items: center;justify-content: center;}
  .history h1{font-size: 16px;font-weight: 400;}
  .history p{font-size: 10px;}
  .eva-body{
    padding: 3% 5% 0;
    bottom: 90px;
    width: 95%;
    height: 200px;
    padding-top: 0;
    p{
      font-family: PingFangSC-Medium;
      color: #151618;
      font-size: 15px;
      font-weight: 600;
      line-height: 25px;
    }
    span {
      color: @attendance-color-2;
      position: relative;
      bottom: 0px;
      right: 10px;
      color: red;
      font-size: 12px;
   }
   .eva-body-ts{
     text-align: right;
     padding: 3% 5% 0;
     padding-top:0;
   }
  }
  .history-btn{position: fixed;bottom: 0;width: 100%;background-color: @attendance-color-3;text-align: center;padding: 0 10px;box-sizing: border-box;height: 85px;}
  .history-btn button{width: 100%;background-color: @attendance-background-color-7;color: @attendance-background-color-1;margin:20px 0;border-radius: 3px;padding: 11px 0}
  .grey-contain_div{display: flex;align-items: center;background-color: white;height: 85px;}

 .eva-body textarea {
   width: 95%;
   padding: 10px;
   background-color: @attendance-background-color-6;
   border-radius: 3px;
   box-sizing: border-box;
   color: @attendance-color-1;
   height: 85%;
   padding-bottom: 15px;
   position: relative;
 }
 .evaluate_content {
    margin-top: 150px;
    font-family: PingFangSC;
    padding: 20px;
    padding-top: 5px ;
    word-wrap: break-word;
}
 .evaluate_content > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: @attendance-background-color-10;
    padding: 10px 20px;
    box-sizing: border-box;
    color: @attendance-color-2;
    margin-bottom: 15px;
    border-radius: 5px;
    position: relative;
}
.evaluate_content > div::after {
    position: absolute;
    content: '';
    background-color: @attendance-background-color-1;
    width: 3px;
    left: 0;
    border-radius: 5px 0 0 5px;
    height: 100%;
}
.evaluate_content > div p {
    color: @attendance-color-2;
    font-size: 15px;
    line-height: 17px;
    margin-bottom: 2px;
    font-family: PingFangSC-Medium;
    color: #151618;
}
.evaluate_content > div h4 {
    color: @attendance-color-1;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
}
 .evaluate_content div .icon_right {
    height: 15px;
    width: 15px;
    background: url(../../../../static/img/arrow.png) center center no-repeat;
    background-size: contain;
}


.w-d-radio-group {
    .img-icon {
      width: 18px;
      height: 18px;
    }
    /deep/.van-cell {
      color: #212f6e;
      padding: 6px 12px;
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/teachEvaluateZtpj.vue